import { Injectable } from '@angular/core';
import { AssetInfo } from '../interfaces/AssetInfo';
import { ApiService } from './communications/api.service';
import { UserRole } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})

export class UserDataService {

  public Id: number | null = null;
  public Name: string | null = null;
  public AssetId: number | null = null;
  public Role: UserRole | undefined | null = null;
  public CallId: number | null = null;
  public ParticipantId: number | null = null;
  public AssistanceToOpen: number | null = null;

  public streamsToTranslate: { [id: string]: OT.Stream } = {};

  public otCallToken: string | null = null;
  public otSession: string | null = null;
  public otApiKey: string | null = null;

  public assetInfo!: AssetInfo;
  public frontCameraDescriptions: string[] = ['back'];
  preferedCamera: string | undefined = undefined;

  public logoHeader: string | null = null;
  public favicon: string | null = null;

  constructor(private apiService: ApiService) {
    this.getDevices();
    this.streamsToTranslate = {};
  }

  public set(id: number | null, name: string, roleId: number | null, assetId: number | null, logo: string | null, favicon: string | null, assistanceId: number | null) {
    this.Id = id;
    this.Name = name;
    this.AssetId = assetId;
    this.Role = roleId;
    //this.ParticipantId = participantId;
    this.AssistanceToOpen = assistanceId;

    if (logo != null && logo != "") {
      this.favicon = favicon;
      this.logoHeader = logo;
    };
  }

  public setParticipantId(participantId: number | null) {
    this.ParticipantId = participantId;
  }

  isMainExpert() {
    return this.Role! == UserRole.Expert;
  }

  isExpert() {
    return this.Role! == UserRole.Expert || this.Role! == UserRole.GuestExpert;
  }

  isTechnician() {
    return this.Role! == UserRole.TechnicianMobile || this.Role! == UserRole.TechnicianGlass || this.Role! == UserRole.TechnicianNoApp;
  }

  getTags() {
    var tags: string[] = [];
    if (this.assetInfo?.tags) tags = this.assetInfo.tags;
    return tags;
  }

  updateTags(tags: string[]) {
    if (this.assetInfo) this.assetInfo.tags = tags;
  }

  SetTranslatedStreamId(stream: OT.Stream) {
    console.log("SETTRANSLATEDSTREAMID", this.Id, stream.connection.connectionId);
    this.streamsToTranslate[stream.connection.connectionId] = stream;
  }

  GetTranslatedStreamId(userConnectionId: string) {
    return this.streamsToTranslate[userConnectionId];
  }

  DeleteTranslatedStreamId(stream: OT.Stream) {
    delete this.streamsToTranslate[stream.connection.connectionId];
  }

  selectDevice(devices: OT.Device[]) {
    console.log("Get devices: " + JSON.stringify(devices.filter(o => o.kind == 'videoInput')));
    this.apiService.sendGeneralInfo("Video Devices Detected", JSON.stringify(devices));
    for (let device of devices.filter(o => o.kind == 'videoInput')) {
      for (let str of this.frontCameraDescriptions!) {
        if (device.label.toLowerCase().includes(str.toLowerCase())) {
          this.preferedCamera = device.deviceId;
          break;
        }
      }
      if (this.preferedCamera)
        break;
    }
  }

  getDevices() {
    OT.getDevices((err, devices) => {
      if (err)
        console.error(err);
      if (devices) {
        this.selectDevice(devices);
      }
    });
  }


}
